<template>
  <div class="tinymce-boxz">
    <div class="form_l">
      <el-input
        size="small"
        v-model="formData.title"
        placeholder="标题(必填)"
      ></el-input>
      <el-input
        size="small"
        v-model="formData.public_time"
        placeholder="发布日期(选填) (格式2019-12-10 10:30)"
      ></el-input>
      <el-select
        v-model="formData.reprinted"
        placeholder="转载自(必填)"
        size="small"
      >
        <el-option
          v-for="item in options"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <el-input
        size="small"
        v-model="formData.sclass_ids"
        placeholder="关联赛事id(例36,34,8)(必填)"
      ></el-input>
      <el-input
        size="small"
        v-model="formData.team_ids"
        placeholder="关联球队id(例25,27,84,9)(必填)"
      ></el-input>
      <el-input
        size="small"
        v-model="formData.schedule_ids"
        placeholder="关联球队交锋id"
      ></el-input>
      <el-button size="mini" type="warning" @click="fnJumpDetailsPage"
        >查看自己发布的新闻</el-button
      >
    </div>
    <Editor ref="editor" :content_s="content_s" />
    <el-button type="primary" @click="editor_fn">确定</el-button>
  </div>
</template>

<script>
import Editor from './cpn/release_cpn.vue'
import { ref, reactive, getCurrentInstance, inject } from 'vue'
import { useRouter } from 'vue-router'
import dayjs from 'dayjs'
export default {
  props: ['AUTH_OBJ', 'token'],
  components: {
    Editor
  },
  setup() {
    // 刷新
    const refresh = inject('reload')
    let { proxy: _this } = getCurrentInstance()
    let router = useRouter()
    // let qs = require('qs')
    let formData = reactive({
      title: '',
      content: '',
      reprinted: '',
      public_time: dayjs().format('YYYY-MM-DD HH:mm'),
      sclass_ids: '',
      team_ids: '',
      schedule_ids: ''
    })
    let options = ref([
      '直播吧',
      '懂球帝',
      '虎扑',
      '雪缘园',
      '腾讯体育',
      '球队官方'
    ])
    let editor = ref(null)
    let content_s = ref(false)
    let from_fn = async () => {
      formData.content = editor.value.content
      // if (
      //   formData.title == '' ||
      //   formData.content == '' ||
      //   formData.sclass_ids == '' ||
      //   formData.team_ids == '' ||
      //   formData.schedule_ids == '' ||
      //   formData.reprinted == ''
      // ) {
      //   _this.$notify({
      //     title: '提示',
      //     message: '除"发布日期"其他选项不得为空',
      //     type: 'error'
      //   })
      //   return
      // }
      try {
        !formData.public_time
          ? delete formData.public_time
          : dayjs().format('YYYY-MM-DD HH:mm')
        let data = new FormData()
        data.append('title', formData.title)
        data.append('content', formData.content)
        data.append('sclass_ids', formData.sclass_ids)
        data.append('team_ids', formData.team_ids)
        data.append('schedule_ids', formData.schedule_ids)
        data.append('reprinted', formData.reprinted)
        data.append('public_time', formData.public_time)
        console.log(data)
        let res = await _this.$http.post(`/auth/user/release_news`, data)
        if (res.data.code === 200) {
          formData.title = ''
          formData.content = ''
          formData.sclass_ids = ''
          formData.team_ids = ''
          formData.schedule_ids = ''
          formData.reprinted = ''
          formData.public_time = dayjs().format('YYYY-MM-DD HH:mm')
          content_s.value = true
          _this.$notify({
            title: '提示',
            message: res.data.message,
            type: 'warning'
          })
          refresh()
        }
      } catch (error) {
        console.log(error.response)
        _this.$notify({
          title: '服务器错误',
          message: error.response.data.message,
          type: 'error'
        })
      }
    }
    // 上传点击
    let editor_fn = () => {
      from_fn()
    }
    // 跳转详情页
    let fnJumpDetailsPage = () => {
      let routeUrl = router.resolve({
        path: `/userinfo/release_news_list`
      })
      window.open(routeUrl.href, '_blank')
    }
    return {
      editor,
      editor_fn,
      formData,
      options,
      content_s,
      fnJumpDetailsPage
    }
  }
}
</script>
<style scoped lang="less">
.tinymce-boxz > textarea {
  display: none;
}
.form_l {
  .el-input {
    width: 30%;
    margin: 10px 20px 10px 0;
  }
}
.el-button {
  float: right;
  margin: 10px;
}
</style>
